import { CloseRounded, Delete } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { deleteSeminar } from '../../../../../redux/actions/seminars'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'

type SeminarDeleteModalProps = {
  open: boolean
  setOpen: (state: boolean) => void
  seminar_id: number | null
}

function SeminarDeleteModal({ open, setOpen, seminar_id }: SeminarDeleteModalProps) {
  const theme = useTheme()
  const formClasses = formsStyles(theme)

  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()

  return (
    <Dialog
      data-testid="deleteSeminarModal"
      open={open}
      fullWidth={true}
      fullScreen={isMobile && true}
      maxWidth={!isMobile && 'sm'}
      sx={formClasses.containerForm}
      onClose={() => setOpen(!open)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('seminar')}
          </Typography>
          <Button onClick={() => setOpen(!open)} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={formClasses.bodyForm}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {t('admin.seminars.delete-seminar-text')}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => setOpen(!open)}>{t('cancel')}</CancelButton>
        <DeleteButton
          autoFocus
          id="btn-handleldelete"
          endIcon={<Delete />}
          onClick={() => {
            dispatch(deleteSeminar(seminar_id))
            setOpen(!open)
          }}
        >
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </Dialog>
  )
}

export default SeminarDeleteModal
